module.exports = __webpack_public_path__ + "static/frontUserNew/img/typeother.d4be265f.svg";